module.exports = __webpack_public_path__ + "img/location-xmark.7bec5764.svg";